<template>
  <svg
    viewBox="0 0 96 96"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m48 19.84a34.09 34.09 0 1 1 -34.08 34.09 34.12 34.12 0 0 1 34.08-34.09m0-4a38.09 38.09 0 1 0 38.08 38.09 38.08 38.08 0 0 0 -38.08-38.09z"
      fill="#4f2b1b"
    />
    <rect
      fill="#85c441"
      height="23"
      rx="11.04"
      width="54.28"
      x="41.72"
      y="73"
    />
    <g fill="#fff">
      <path
        d="m52.15 78.29v-.11c0-.26.33-.35.55-.36.54 0 .6.38.7.9.49 2.6 1.08 5.47 2.07 9.7l1.76-9.89a.59.59 0 0 1 .54-.45c.28 0 .54.1.56.45l-2 10c-.09.28-.47 2.54-.8 2.54-.18 0-.35 0-.46-.24-1.07-4.17-1.77-8.4-2.92-12.54z"
      />
      <path
        d="m60.35 88.93v-3.43s-.29-4.1-.27-6.59v-.91c2.77-.23 3.08 0 3.08.34 0 .13-.09.39-.21.41h-1.9a.15.15 0 0 0 -.12.17c0 1.84.18 3.2.28 5.1a19.36 19.36 0 0 0 2 0c.59 0 .19 1 .19 1h-2.16v4.07c.41.11 2.57-.33 2.57.44a.41.41 0 0 1 -.32.45h-.08c-.64 0-3.06.25-3.07-.26z"
      />
      <path
        d="m65.6 83.71c0-1.37.31-4 1.82-4.77.87-.42 3.14-.25 3.14 1.15a.38.38 0 0 1 -.39.43c-.62 0-.85-.94-1.74-.94h-.07c-1.61.09-1.89 2.53-1.89 3.84v.35a24.65 24.65 0 0 0 .45 4.67c.17.82.64 1.69 1.65 1.69h.09c1.58-.13 1.64-2.13 1.58-3.13l-.14-2.58a15.42 15.42 0 0 1 -1.56.09c-.16-.1-.21-.54-.21-.56 0-.52 1.2-.42 2.33-.43.52.14.45 1 .51 2.09v.17c.1 1.9.26 5.13-2.27 5.25a1.93 1.93 0 0 1 -.34 0c-2.35.11-2.96-2.76-2.96-7.32z"
      />
      <path
        d="m73.77 78.39c.1-1.6 1.15-1.18 1.44 0 .44 1.74.77 3.33 2.67 12.56 0 .38-.52.68-.84.12l-.62-3.13-2.35.34c-.14.82-.27 2.37-.3 3.1 0 .42-.78.32-.77 0zm.33 8.12v.94l2.17-.32-1.7-7.75c-.1 1.07-.42 6.05-.47 7.13z"
      />
      <path
        d="m80 78.39c.33-.63.83-.07 1 .18 1 3 1.76 6 3 9.16l.17-2.44a62.93 62.93 0 0 0 .26-6.29.65.65 0 0 1 .67-.43.51.51 0 0 1 .48.22c-.31 3.76-.45 7.77-.57 11.78v.22c0 .09-.26.33-.42.33a.81.81 0 0 1 -.48-.33c-1.08-3.25-2.3-6.44-3.35-9.72l-.14 9.93c-.4.91-1 .44-1-.09z"
      />
    </g>
    <path
      d="m72.19 39.72c-1.8-1.13-4.44-1.61-6.4-2.26-4.56-1.23-10.73-.81-14.25 2.77-1.77 1.8-3.6 6.05-2.84 8.88a26.88 26.88 0 0 0 -2.2 3.11 16.44 16.44 0 0 1 -1.2-2.83c-.47-1.75.12-3.26.06-5.11a8.71 8.71 0 0 0 -3.64-7.14c-4.37-3.14-12.4-4.25-17.58-2.83a1.39 1.39 0 0 0 -.82 2 2.16 2.16 0 0 0 .37.37c2.43 7.33 8.83 20.17 17.73 16 1.5 3 1.22 4.93.72 8.66a33.12 33.12 0 0 0 .73 11.44 1.39 1.39 0 0 0 1.7 1l2.21-.55a1.41 1.41 0 0 0 1-1.7c-1-4.68-1.18-9.32.56-13.86a.59.59 0 0 0 0-.13 20.88 20.88 0 0 1 2.86-5.1c7.39 6 16.47-3.75 20.76-10.19a1.28 1.28 0 0 0 .24-.11 1.4 1.4 0 0 0 -.01-2.42zm-.64-.18h-.08c.22 0 .32.06.08 0zm-46.79-5.23c-.15 0-.13 0 0 0z"
      fill="#85c441"
    />
  </svg>
</template>
